import './robots.txt';
import './humans.txt';
import './pagespeed-test.html';
import './images/avatar.png';
import './images/avatar@2x.png';
import './images/sc-logo-mono-gem.svg';
import './images/sc-logo-color-gem.svg';
import './images/lady.png';
import './images/network.jpg';
import './images/ben-franklin.jpg';
import './images/success.jpg';
import './images/sad-email.svg';
import './images/report.svg';
import './images/pillar/featured-learning.png';
import './images/pillar/featured-review.png';
import './images/pillar/featured-roundup.png';
import './images/backgrounds/grid.svg';
import './images/backgrounds/prism.svg';
import './images/backgrounds/random-dots.svg';
import './images/backgrounds/sunburst.svg';
import './images/backgrounds/waves.svg';
import 'gridstrap/svg-symbols/chevron-right-circle.svg';
import 'gridstrap/svg-symbols/circle-email.svg';
import 'gridstrap/svg-symbols/quotation-mark.svg';
import 'gridstrap/svg-symbols/magnifying-glass.svg';
import 'gridstrap/svg-symbols/size-small.svg?sprite';
import 'gridstrap/svg-symbols/size-mid.svg?sprite';
import 'gridstrap/svg-symbols/size-enterprise.svg?sprite';
import 'gridstrap/svg-symbols/circle-outline-checkmark.svg?sprite';
import './images/calendar.svg?sprite';
import './images/calendar.svg';
import './images/icon-apple.svg';
import './images/icon-google.svg';
import './images/icon-yahoo.svg';
import './images/icon-outlook.svg';
import './images/icon-outlookcom.svg';
import './images/loader-bars.svg';
import './images/logos/companies/apple.png';
import './images/logos/companies/boeing.png';
import './images/logos/companies/disney.png';
import './images/logos/companies/fedex.png';
import './images/logos/companies/ge.png';
import './images/logos/companies/home-depot.png';
import './images/logos/companies/marriott.png';
import './images/logos/companies/walmart.png';
import './images/logos/companies/ae.png';
import './images/logos/companies/bluecross-blueshield.png';
import './images/logos/companies/caterpillar.png';
import './images/logos/companies/energizer.png';
import './images/logos/companies/general-mills.png';
import './images/logos/companies/ibm.png';
import './images/logos/companies/kia.png';
import './images/logos/companies/kimberly-clark.png';
import './images/logos/companies/orange-theory.png';
import './images/logos/companies/pandora.png';
import './images/logos/companies/tampa-bay-buccaneers.png';
import './images/logos/companies/toshiba.png';
import './images/logos/companies/usa-olympic-committee.png';
import './images/logos/companies/modal-sidebar.png';
import './images/logos/press/accounting-web.png';
import './images/logos/press/food-logistics.png';
import './images/logos/press/forbes.png';
import './images/logos/press/inc.png';
import './images/logos/press/neil-patel.png';
import './images/logos/press/new-york-times.png';
import './images/logos/press/tech-impact.png';
import './images/logos/press/the-balance.png';
import './images/logos/products/acumatica.png';
import './images/logos/products/blackbaud.png';
import './images/logos/products/buildium.png';
import './images/logos/products/eci.png';
import './images/logos/products/fishbowl.png';
import './images/logos/products/oracle-netsuite.png';
import './images/logos/products/quickbooks.png';
import './images/logos/products/sage.png';
import '../gridstrap/lib/smooth-scroll';
import '../gridstrap/lib/svg4everybody';
import '../gridstrap/lib/blazy';
import '../gridstrap/lib/scroll-save';
// These should clearly stay in Gridstrap
import 'gridstrap/scss/base.scss';
import 'gridstrap/components/article';
import 'gridstrap/components/avatar';
import 'gridstrap/components/bar-chart'; // product
import 'gridstrap/components/bottom-bar'; // buyers-guide
import 'gridstrap/components/breadcrumb-trail';
import 'gridstrap/components/button';
import 'gridstrap/components/card';
import 'gridstrap/components/data';
import 'gridstrap/components/doughnut-chart'; // product
import 'gridstrap/components/faq-list';
import 'gridstrap/components/flex-image';
import 'gridstrap/components/form-error';
import 'gridstrap/components/form-field';
import 'gridstrap/components/form-footer';
import 'gridstrap/components/form-heading';
import 'gridstrap/components/form-hidden';
import 'gridstrap/components/form-locale';
import 'gridstrap/components/form-option';
import 'gridstrap/components/form-option-list';
import 'gridstrap/components/form-search';
import 'gridstrap/components/form';
import 'gridstrap/components/hamburger-menu';
import 'gridstrap/components/header-menu';
import 'gridstrap/components/hero/index';
import 'gridstrap/components/highlight-animation'; // buyers-guide
import 'gridstrap/components/horizontal-scroller';
import 'gridstrap/components/hover-cta';
import 'gridstrap/components/list';
import 'gridstrap/components/logo-grid';
import 'gridstrap/components/markdown-toc';
import 'gridstrap/components/modal';
import 'gridstrap/components/nav-bar';
import 'gridstrap/components/pagination';
import 'gridstrap/components/person-card'; // buyers-guide
import 'gridstrap/components/phantom-card'; // buyers-guide
import 'gridstrap/components/pillar-featured';
import 'gridstrap/components/pillar-item';
import 'gridstrap/components/pillar-top-items';
import 'gridstrap/components/privacy-badge';
import 'gridstrap/components/product-card';
import 'gridstrap/components/product-comparison';
import 'gridstrap/components/product-cta-card';
import 'gridstrap/components/product-list';
import 'gridstrap/components/product-pick';
import 'gridstrap/components/product-picks';
import 'gridstrap/components/product-pricing';
import 'gridstrap/components/product-review'; // product
import 'gridstrap/components/product-review-summary';
import 'gridstrap/components/product-screenshot-card';
import 'gridstrap/components/product-specs';
import 'gridstrap/components/progress-meter';
import 'gridstrap/components/rating-compact';
import 'gridstrap/components/rating-full';
import 'gridstrap/components/rating-ring';
import 'gridstrap/components/read-more';
import 'gridstrap/components/scale';
import 'gridstrap/components/screenshot-carousel'; // product
import 'gridstrap/components/screenshot-strip'; // product
import 'gridstrap/components/share-buttons';
import 'gridstrap/components/sidebar-definition-list';
import 'gridstrap/components/sidebar-heading';
import 'gridstrap/components/sidebar-product-list';
import 'gridstrap/components/sidebar-spec-list';
import 'gridstrap/components/sliding-footer'; // buyers-guide
import 'gridstrap/components/speech-bubble';
import 'gridstrap/components/tab-bar';
import 'gridstrap/components/table-of-contents'; // about
import 'gridstrap/components/tags';
import 'gridstrap/components/template';
import 'gridstrap/components/testimonial-carousel';
import 'gridstrap/components/testimonial';
import 'gridstrap/components/top-product';
import 'gridstrap/components/outline-button';
import 'gridstrap/components/wizard';
import '../private/liquid/components/byline';
import '../private/liquid/components/follow-buttons';
import '../private/liquid/components/footer';
import '../private/liquid/components/header';
import '../private/liquid/components/mobile-headers';
import '../private/liquid/components/waitlist-bottom-bar'; // buyers-guide
import '../private/liquid/components/appointment'; // buyers-guide
import 'lite-vimeo-embed';
import 'lite-youtube-embed';
import 'lite-youtube-embed/src/lite-yt-embed.css';

import './embeds/usa-burnout-rate/index.html';
import './embeds/usa-burnout-rate/settings.js';
import './embeds/usa-burnout-rate/assets/banner-3.svg';
import './embeds/usa-burnout-rate/assets/icon-1.svg';
import './embeds/usa-burnout-rate/assets/sc-logo-color-full.svg';

import $ from 'gridstrap/lib/gs-zepto';

import * as Sentry from '@sentry/browser';

// Browser errors on the legacy surface. Same astro-sc project and release as
// the Astro pages (src/layouts/tracking/Sentry.astro), tagged app:legacy like
// the worker's legacy captures (src/legacy/sentry.ts). No tracing: this bundle
// loads on every legacy page, and the Astro pages already sample performance.
declare const __SENTRY_RELEASE__: string;
// Header and query-param key substrings Sentry v10 scrubbed when sendDefaultPii was off.
const PII_KEY_SNIPPETS = ['forwarded', '-ip', 'remote-', 'via', '-user'];
Sentry.init({
	dsn: 'https://a3ef5814eb4e7c15d246432ff9ab6436@o164252.ingest.us.sentry.io/4509169637261312',
	environment: 'production',
	release: __SENTRY_RELEASE__,
	// What v10's sendDefaultPii: true collected here: the visitor's IP, which
	// Sentry infers at ingest (userInfo) and counts "users affected" by. The
	// rest is the v10 baseline, so an integration added later cannot start
	// shipping lead-form bodies or cookies. Same block as
	// src/layouts/tracking/Sentry.astro.
	dataCollection: {
		userInfo: true,
		cookies: false,
		httpHeaders: { request: { deny: PII_KEY_SNIPPETS }, response: { deny: PII_KEY_SNIPPETS } },
		httpBodies: [],
		urlQueryParams: { deny: PII_KEY_SNIPPETS },
		genAI: { inputs: false, outputs: false },
		databaseQueryData: false,
		queues: false,
		graphQL: { document: false, variables: false },
	},
	initialScope: { tags: { app: 'legacy' } },
});

$('body').trigger('gs:loaded');
